import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeLoadLineMutationVariables = Types.Exact<{
  input: Types.MergeLoadLineInput;
}>;


export type MergeLoadLineMutation = { __typename?: 'Mutation', mergeLoadLine: { __typename?: 'LoadLinePayload', loadLine?: { __typename?: 'LoadLineStateData', tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteLoadLineMutationVariables = Types.Exact<{
  input: Types.DeleteLoadLineInput;
}>;


export type DeleteLoadLineMutation = { __typename?: 'Mutation', deleteLoadLine: { __typename?: 'LoadLinePayload', loadLine?: { __typename?: 'LoadLineStateData', tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignOrderToLoadMutationVariables = Types.Exact<{
  input: Types.AssignOrderToLoadInput;
}>;


export type AssignOrderToLoadMutation = { __typename?: 'Mutation', assignOrderToLoad: { __typename?: 'LoadLinePayload', loadLine?: { __typename?: 'LoadLineStateData', tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLoadLineStopMutationVariables = Types.Exact<{
  input: Types.SetLoadLineStopInput;
}>;


export type SetLoadLineStopMutation = { __typename?: 'Mutation', setLoadLineStop: { __typename?: 'LoadLinePayload', loadLine?: { __typename?: 'LoadLineStateData', tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsLoadLineStateFieldsFragment = { __typename?: 'LoadLineStateData', tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsLoadLineStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsLoadLineStateFields on LoadLineStateData {
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsLoadLineStateFields"});
export const MergeLoadLineDocument = new TypedDocumentString(`
    mutation MergeLoadLine($input: MergeLoadLineInput!) {
  mergeLoadLine(input: $input) {
    loadLine {
      ...LogisticsLoadLineStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadLineStateFields on LoadLineStateData {
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}`);
export const DeleteLoadLineDocument = new TypedDocumentString(`
    mutation DeleteLoadLine($input: DeleteLoadLineInput!) {
  deleteLoadLine(input: $input) {
    loadLine {
      ...LogisticsLoadLineStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadLineStateFields on LoadLineStateData {
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}`);
export const AssignOrderToLoadDocument = new TypedDocumentString(`
    mutation AssignOrderToLoad($input: AssignOrderToLoadInput!) {
  assignOrderToLoad(input: $input) {
    loadLine {
      ...LogisticsLoadLineStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadLineStateFields on LoadLineStateData {
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}`);
export const SetLoadLineStopDocument = new TypedDocumentString(`
    mutation SetLoadLineStop($input: SetLoadLineStopInput!) {
  setLoadLineStop(input: $input) {
    loadLine {
      ...LogisticsLoadLineStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadLineStateFields on LoadLineStateData {
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeLoadLine: build.mutation<MergeLoadLineMutation, MergeLoadLineMutationVariables>({
      query: (variables) => ({ document: MergeLoadLineDocument, variables })
    }),
    DeleteLoadLine: build.mutation<DeleteLoadLineMutation, DeleteLoadLineMutationVariables>({
      query: (variables) => ({ document: DeleteLoadLineDocument, variables })
    }),
    AssignOrderToLoad: build.mutation<AssignOrderToLoadMutation, AssignOrderToLoadMutationVariables>({
      query: (variables) => ({ document: AssignOrderToLoadDocument, variables })
    }),
    SetLoadLineStop: build.mutation<SetLoadLineStopMutation, SetLoadLineStopMutationVariables>({
      query: (variables) => ({ document: SetLoadLineStopDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeLoadLineMutation, useDeleteLoadLineMutation, useAssignOrderToLoadMutation, useSetLoadLineStopMutation } = injectedRtkApi;
